// Anonymous journey tracking: pages in order + which nav controls get used. No IP, no user id, no cookie —
// a random per-tab id (sessionStorage) that dies with the tab. Honors Do Not Track. Admins are excluded (see AppRouter).
const ENDPOINT = `${process.env.REACT_APP_BACKEND_URL}/api/insights/events`;
const DNT = typeof navigator !== "undefined" && (navigator.doNotTrack === "1" || window.doNotTrack === "1");

let enabled = false;
let queue = [];
let timer = null;

const sid = () => {
  try {
    let s = sessionStorage.getItem("wall_sid");
    if (!s) { s = Array.from(crypto.getRandomValues(new Uint8Array(12)), (b) => (b % 36).toString(36)).join(""); sessionStorage.setItem("wall_sid", s); }
    return s;
  } catch { return null; }
};
const nextSeq = () => { const n = Number(sessionStorage.getItem("wall_seq") || 0) + 1; sessionStorage.setItem("wall_seq", String(n)); return n; };

const flush = (beacon = false) => {
  clearTimeout(timer); timer = null;
  const id = sid();
  if (!queue.length || !id) return;
  const body = JSON.stringify({ sid: id, device: window.innerWidth < 768 ? "mobile" : "desktop", lang: (document.documentElement.lang || navigator.language || "").slice(0, 5), events: queue.splice(0, 60) });
  if (beacon && navigator.sendBeacon) { navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "application/json" })); return; }
  fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
};

const push = (ev) => {
  if (!enabled || DNT) return;
  queue.push({ ...ev, seq: nextSeq() });
  if (queue.length >= 20) flush();
  else if (!timer) timer = setTimeout(() => flush(), 4000);
};

export const setInsightsEnabled = (on) => { enabled = !!on; };
export const trackView = (path) => push({ type: "view", path });
export const trackNav = (label, path = window.location.pathname) => push({ type: "nav", label, path });

// Any element with data-insight="Label", or links/buttons inside <nav>/<header>, counts as a "nav function".
let installed = false;
export const installNavTracking = () => {
  if (installed) return; installed = true;
  document.addEventListener("click", (e) => {
    const el = e.target.closest?.("[data-insight], nav a, nav button, header a, header button");
    if (!el) return;
    const label = el.dataset.insight || el.getAttribute("aria-label") || el.textContent.replace(/\s+/g, " ").trim().slice(0, 60);
    if (label) trackNav(label);
  }, true);
  window.addEventListener("pagehide", () => flush(true));
  document.addEventListener("visibilitychange", () => { if (document.hidden) flush(true); });
};
